import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../actions/fillCombo_action";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import { getVendorAuditTrackerList_action } from "../../../../actions/admin_module_action/preSetupTracker_action/vendorView_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
} from "../../../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";
import {
  getVendorStaffList_action,
} from "../../../../actions/admin_module_action/hall_manager_action/work_updation_action";
// import 'bootstrap-icons/font/bootstrap-icons.css';

const styles = {
  width: "100%",
};

class VendorView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      VendorAuditTrackerList: [],
      isHallManagerModalOpen: false,
      HallManagerList: []
    };

    this.getVendorAuditTrackerList = this.getVendorAuditTrackerList.bind(this);
    this.renderWorkUpdationList = this.renderWorkUpdationList.bind(this);
  }

  componentDidMount() {
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");
    this.getVendorAuditTrackerList();
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    const { } = this.state;
    this.setState({ isLoading: !flag ? false : true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getVendorAuditTrackerList() {
    const {
      zoneId,
      ExhibitorName,
      VendorName,
      StatusID,
      hallId,
      ExhRegNo,
      serviceId,
    } = this.state;

    this.setState({ isLoading: true });

    try {
      const data = await this.props.getVendorAuditTrackerList_action(
        hallId,
        "",
        ExhRegNo,
        ExhibitorName,
        VendorName,
        StatusID,
        zoneId,
        serviceId
      );

      // Handle API error
      if (data.error === 1) {
        toastError(data.error);
        return;
      }

      console.log(
        "sagar---------------------->",
        this.transformData(data.data[0])
      );

      // Update state
      this.setState({
        // VendorAuditTrackerList: this.transformData(data.data[0]),
        VendorAuditTrackerList: data.data[0],
      });
    } catch (err) {
      console.error("Error in getVendorAuditTrackerList:", err);
      toastError(
        "Something went wrong while fetching Hall Manager Work Updation list."
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  transformData = (data) => {
    const result = {};
    console.log("getVendorAuditTrackerList:", data.length);

    data.forEach((item) => {
      const {
        ServiceName,
        ServiceID,
        CompanyName,
        VendorName,
        MobileNo,
        WorkOrderID,
        VendorUserID,
        VendorAccountID,
        PrimaryEmail,
        HallName,
        HallStatus,
        IsServiceAllocated,
      } = item;

      if (!result[ServiceName]) result[ServiceName] = {};

      // If not allocated, mark and skip further processing
      if (IsServiceAllocated !== 1) {
        result[ServiceName][CompanyName] = "Not Allocated";
        return;
      }

      // If previously marked as "Not Allocated", reset to array
      if (result[ServiceName][CompanyName] === "Not Allocated") {
        result[ServiceName][CompanyName] = [];
      }

      if (!result[ServiceName][CompanyName]) {
        result[ServiceName][CompanyName] = [];
      }

      // Match vendor by unique ID (safer than name)
      const existingVendor = result[ServiceName][CompanyName].find(
        (v) => v.VendorAccountID === VendorAccountID
      );

      if (existingVendor) {
        // Prevent duplicate hall entries
        const hallExists = existingVendor.Halls.some(
          (h) => h.HallName === HallName
        );
        if (!hallExists) {
          existingVendor.Halls.push({ HallName, Status: HallStatus });
        }
      } else {
        result[ServiceName][CompanyName].push({
          VendorName,
          MobileNo,
          PrimaryEmail,
          ServiceID,
          WorkOrderID,
          VendorUserID,
          VendorAccountID,
          Halls: [{ HallName, Status: HallStatus }],
        });
      }
    });

    return result;
  };

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
      },
      () => this.getVendorAuditTrackerList()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  renderWorkUpdationList(apiData) {
    if (!Array.isArray(apiData) || apiData.length === 0) {
      return <p className="text-center mt-4">Record not found</p>;
    }

    /* ---------------------------------------
       1️⃣ BUILD MATRIX: Service → Company → Vendor → Halls
    --------------------------------------- */
    const matrix = {};
    const companiesMap = new Map();

    console.log("apiData----------->", apiData)
    apiData.forEach(item => {
      const {
        ServiceName,
        ServiceID,
        CompanyName,
        VendorName,
        VendorAccountID,
        VendorUserID,
        WorkOrderID,
        MobileNo,
        PrimaryEmail,
        HallID,
        HallName,
        HallStatus
      } = item;

      const service = ServiceName;
      const company = CompanyName?.trim();
      // --- collect companies (for headers)
      const companyKey = `${company}_${VendorAccountID}_${VendorUserID}`;
      if (!companiesMap.has(companyKey)) {
        companiesMap.set(companyKey, {
          companyName: company,
          VendorAccountID,
          VendorUserID,
          WorkOrderID
        });
      }

      // --- init service
      if (!matrix[service]) matrix[service] = {};

      // --- init company
      if (!matrix[service][company]) matrix[service][company] = [];

      // --- vendor uniqueness
      let vendor = matrix[service][company].find(
        v => v.VendorAccountID === VendorAccountID
      );

      if (!vendor) {
        vendor = {
          VendorName,
          VendorAccountID,
          VendorUserID,
          WorkOrderID,
          ServiceID,
          MobileNo,
          PrimaryEmail,
          Halls: []
        };
        matrix[service][company].push(vendor);
      }

      // --- avoid duplicate halls
      if (!vendor.Halls.some(h => h.HallID === HallID)) {
        vendor.Halls.push({
          HallID,
          HallName,
          Status: HallStatus
        });
      }
    });

    /* ---------------------------------------
       2️⃣ DYNAMIC ROWS & COLUMNS
    --------------------------------------- */
    const services = Object.keys(matrix);
    const companies = Array.from(companiesMap.values()).sort((a, b) =>
      a.companyName?.localeCompare(b.companyName)
    );

    /* ---------------------------------------
       3️⃣ STATUS COLOR
    --------------------------------------- */
    const getStatusColor = status => {
      switch (status?.toLowerCase()) {
        case "completed":
          return "bg-green-100 text-green-700 border-green-400";
        case "pending":
          return "bg-red-100 text-red-700 border-red-400";
        case "inprogress":
          return "bg-yellow-100 text-yellow-700 border-yellow-400";
        default:
          return "bg-gray-100 text-gray-600 border-gray-300";
      }
    };

    /* ---------------------------------------
       4️⃣ RENDER TABLE
    --------------------------------------- */
    return (
      <div
        class="table-responsive sticky-table-wrapper border-bottom service-list-grid-1 mx-2 p-0"

      >
        <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0 me-3">

          {/* ------------ HEADER ------------ */}
          <thead class="table-light">
            <tr>
              <th className="text-center">Services</th>

              {companies.map(c => (
                <th
                  key={`${c.companyName}_${c.VendorAccountID}`}
                  className="text-center"
                >
                  {c.companyName}
                  <a
                    className="mx-1"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.navigateToVendorAndScopofwork(
                        c.VendorUserID,
                        c.VendorAccountID,
                        c.WorkOrderID
                      )
                    }
                  >
                    <i className="ri-external-link-fill"></i>
                  </a>
                </th>
              ))}
            </tr>
          </thead>

          {/* ------------ BODY ------------ */}
          <tbody>
            {services.map(service => (
              <tr key={service}>
                <td className="text-center fw-semibold">
                  {service}
                </td>

                {companies.map(company => {
                  const vendorList = matrix[service]?.[company.companyName];

                  return (
                    <td
                      key={`${service}_${company.companyName}`}
                      className={
                        vendorList
                          ? "p-2 align-top"
                          : "text-center align-middle fst-italic text-muted"
                      }
                    >
                      {!vendorList ? (
                        'Not Allocated'
                      ) : (
                        vendorList.map((v, i) => (
                          <div
                            key={i}
                            className="mb-3 pb-2 border-b border-gray-200 last:border-0"
                          >
                            <div className="font-medium text-blue-700">
                              <div className="d-flex" style={{ justifyContent: 'space-between' }}>
                                <span >
                                  <i class="ri-user-3-line grid-icon"></i>{" "}
                                  {v.VendorName}
                                </span>
                                <a className="p-0">
                                  {/* <i
                                    className="fa fa-users fa-solid grid-icon mx-1 p-0"
                                    title="View Staff"
                                    onClick={() =>
                                      this.getVendorStaffList(
                                        v.VendorAccountID,
                                        v.ServiceID
                                      )
                                    }
                                  ></i> */}

                                  <span class="material-symbols-outlined grid-icon gi-icon mx-1" title="View Staff"
                                    onClick={() =>
                                      this.getVendorStaffList(
                                        v.VendorAccountID,
                                        v.ServiceID
                                      )
                                    }>
                                    groups
                                  </span>
                                </a>
                              </div>
                            </div>
                            <div className="text-xs text-gray-600">
                              <i class="ri-phone-line grid-icon"></i>{" "}
                              {v.MobileNo}
                            </div>
                            <div className="text-xs text-gray-600">
                              <i class="ri-mail-line grid-icon"></i>{" "}
                              {v.PrimaryEmail}
                            </div>
                            <div className="mt-1 d-flex flex-wrap gap-1">
                              {v.Halls.map((h, idx) => (
                                <button
                                  className="hall-btn"
                                  style={{
                                    backgroundColor:
                                      h.Status == "InProgress"
                                        ? "#ffce7f"
                                        : h.Status == "Completed"
                                          ? "#cffae8"
                                          : "#ececec",
                                  }}
                                >
                                  {h.HallName}
                                </button>
                              ))}
                            </div>
                          </div>

                        ))
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>

        </table>
      </div>
    );
  }

  async getVendorStaffList(VendorID, ServiceID) {
    if (VendorID && ServiceID) {
      this.setState({ isLoading: true });
      try {
        const data = await this.props.getVendorStaffList_action(
          VendorID,
          ServiceID
        );
        // Handle API error
        if (data.error === 1) {
          toastError(data.error);
          return;
        }
        // Update state
        this.setState({
          HallManagerList: this.groupStaffByService(data.data[0]),
          isHallManagerModalOpen: true,
        });
      } catch (err) {
        console.error("Error:", err);
        toastError("Something went wrong!");
      } finally {
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({ HallManagerList: [], isHallManagerModalOpen: true });
    }
  }

  groupStaffByService(data) {
    // Group by ServiceName first
    const serviceGroups = data.reduce((acc, curr) => {
      const key = curr.ServiceName;
      if (!acc[key])
        acc[key] = {
          WorkOrderID: curr.WorkOrderID,
          ServiceName: curr.ServiceName,
          StaffList: [],
        };
      acc[key].StaffList.push(curr);
      return acc;
    }, {});

    // For each service, merge people across types
    const result = Object.values(serviceGroups).map((service) => {
      const personGroups = service.StaffList.reduce((acc, curr) => {
        const key = `${curr.PersonName}|${curr.EmailID}|${curr.MobileNumber}`;
        if (!acc[key])
          acc[key] = {
            PersonName: curr.PersonName,
            EmailID: curr.EmailID,
            MobileNumber: curr.MobileNumber,
            Types: new Set(),
          };
        acc[key].Types.add(curr.Type);
        return acc;
      }, {});

      const finalPeople = Object.values(personGroups).map((p) => {
        const types = Array.from(p.Types);
        const TypeName = types.length === 3 ? "All" : types.join(" / ");
        return { ...p, TypeName };
      });

      return {
        WorkOrderID: service.WorkOrderID,
        ServiceName: service.ServiceName,
        Staff: finalPeople,
      };
    });

    return result;
  }


  render() {
    const {
      isLoading,
      isUpdateModalOpen,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      RoleID,
      isHallManagerModalOpen,
      HallManagerList
    } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {RoleID == 16 && <HeaderWithLogo />}
        {/* <ExhibitorDrawer /> */}
        <>
          {/* <AdminDrawer /> */}
          {/*app-content open*/}
          <div
            className="app-content with-dr-container com-height admin-top-space"
            style={{ marginLeft: 0 }}
          >
            <main id="main" className="p-2">
              <section className="section" style={{ padding: 0 }}>
                <div className="row m-0">
                  <div className="container-fluid">
                    <div className="row g-2 align-items-end w-100">

                      {/* Hall */}
                      <div className="col-lg-2 col-md-4 col-sm-6 col-12">
                        <label className="ms-1">Hall</label>
                        <select
                          className="form-control"
                          value={hallId}
                          onChange={(e) =>
                            this.setState({ hallId: e.target.value }, () => {
                              if (e.target.value !== "") {
                                this.getFillList(
                                  HallZoneActionId,
                                  this.state.exhibitionID,
                                  e.target.value,
                                  "",
                                  "",
                                  "",
                                  false
                                );
                              } else {
                                this.setState({ zoneList: [] });
                              }
                            })
                          }
                        >
                          <option value="">Select</option>
                          {hallList.map((data) => (
                            <option key={data.HallId} value={data.HallId}>
                              {data.HallName}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Zone */}
                      <div className="col-lg-2 col-md-4 col-sm-6 col-12">
                        <label className="ms-1">Zone</label>
                        <select
                          className="form-control"
                          value={zoneId}
                          onChange={(e) => this.setState({ zoneId: e.target.value })}
                        >
                          <option value="">Select</option>
                          {zoneList.map((data) => (
                            <option key={data.HallZoneMappingID} value={data.HallZoneMappingID}>
                              {data.Zone}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Service Partner Company */}
                      <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <label className="ms-1">Service Partner Company</label>
                        <input
                          type="text"
                          className="form-control"
                          value={VendorName}
                          onChange={(e) => this.setState({ VendorName: e.target.value })}
                          maxLength={100}
                        />
                      </div>

                      {/* Services */}
                      <div className="col-lg-2 col-md-4 col-sm-6 col-12">
                        <label className="ms-1">Services</label>
                        <select
                          className="form-control"
                          value={serviceId}
                          onChange={(e) => this.setState({ serviceId: e.target.value })}
                        >
                          <option value="">Select</option>
                          {serviceList.map((data) => (
                            <option key={data.ServiceID} value={data.ServiceID}>
                              {data.Name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Search Button */}
                      <div className="col-lg-2 col-md-4 col-sm-12 col-12">
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-aqua"
                            onClick={() => this.getVendorAuditTrackerList()}
                          >
                            Search
                          </button>

                          <button
                            className="btn btn-gray"
                            onClick={() => this.handleClear()}
                          >
                            Clear
                          </button>
                        </div>
                      </div>


                    </div>

                    <div className="legend-parent" >
                      <div className="legend d-flex align-items-center ms-2  w-100 p-0 my-2">
                        <span>
                          <div className="legend-box pending" />
                          Pending
                        </span>
                        <span>
                          <div className="legend-box inprogress" />
                          In Progress
                        </span>
                        <span>
                          <div className="legend-box completed" />
                          Completed
                        </span>
                        <span>
                          <div className="legend-box delayed" />
                          Delayed
                        </span>
                      </div>
                    </div>
                  </div>

                  {this.renderWorkUpdationList(this.state.VendorAuditTrackerList)}

                  {/* <!-- Hall Script --> */}
                </div>
              </section>
            </main>
          </div>
        </>

        <Modal
          isOpen={isHallManagerModalOpen}
          onRequestClose={() =>
            this.setState({ isHallManagerModalOpen: false })
          }
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div class="modal-header p-2">
                <h6 class="modal-title">
                  Staff Details
                </h6>

                {/* <div className="ms-auto d-flex align-items-center gap-3">
                  <button
                    type="button"
                    className="btn-close ms-2"
                    data-bs-dismiss="modal"
                    onClick={() =>
                      this.setState({ isHallManagerModalOpen: false })
                    }
                    style={{ fontSize: "18px !important" }}
                  />
                </div> */}
              </div>

              <div className="modal-body">
                {HallManagerList.length > 0 ? (
                  <div style={{ maxHeight: 500, overflowY: "auto", overflowX: 'hidden' }}>
                    {HallManagerList.map((data, index) => (
                      <div key={index} className="mb-4">
                        {/* Staff Cards */}
                        <div className="row g-3">
                          {data.Staff && data.Staff.length > 0 ? (
                            data.Staff.map((item, idx) => {
                              // 🔹 Dynamic badge color mapping
                              let badgeColor = "#6c757d"; // default gray
                              switch (item.TypeName) {
                                case "Pre-Setup":
                                  badgeColor = "#0d6efd"; // blue
                                  break;
                                case "Dismantling":
                                  badgeColor = "#dc3545"; // red
                                  break;
                                case "All":
                                  badgeColor = "#198754"; // green
                                  break;
                                case "EventDays":
                                  badgeColor = "#ffc107"; // yellow
                                  break;
                                default:
                                  badgeColor = "#6610f2"; // fallback gray
                              }

                              return (
                                <div
                                  key={idx}
                                  className="col-md-3 col-sm-6 position-relative"
                                >
                                  <div
                                    className="card h-100 m-0 shadow-sm border rounded-3 position-relative"
                                    style={{
                                      borderColor: "#343a40",
                                      borderWidth: "2px",
                                    }}
                                  >
                                    {/* Event Type Badge */}
                                    <span
                                      className="badge position-absolute top-0 end-0 m-2"
                                      style={{
                                        backgroundColor: badgeColor,
                                        color: "white",
                                        fontSize: "0.75rem",
                                        borderRadius: "0.5rem",
                                        padding: "0.35rem 0.6rem",
                                        zIndex: 10,
                                      }}
                                    >
                                      {item.TypeName}
                                    </span>

                                    <div className="card-body mt-3 p-1 d-flex align-items-center">
                                      <div className="me-3">
                                        <div
                                          className="bg-light rounded-circle d-flex align-items-center justify-content-center"
                                          style={{ width: 50, height: 50 }}
                                        >
                                          <i className="ri-user-3-line fs-4 grid-icon" />
                                        </div>
                                      </div>
                                      <div>
                                        <h6 className="mb-1 fw-bold">
                                          {item.PersonName}
                                        </h6>
                                        <p className="mb-0 text-muted small">
                                          <i className="ri-phone-line grid-icon me-1" />
                                          {item.MobileNumber}
                                        </p>
                                        <p className="mb-0 text-muted small">
                                          <i className="ri-mail-line grid-icon me-1" />
                                          {item.EmailID}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <p className="text-muted small">
                              No staff found for this service.
                            </p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>Record not found</div>
                )}
              </div>

              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() =>
                      this.setState({
                        isHallManagerModalOpen: false,
                      })
                    }
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getVendorAuditTrackerList_action,
    getVendorStaffList_action
  })(VendorView)
);
